<template>
    <Home fit="cover">
        <template #picture>
            <!-- background -->
            <source media="(orientation: portrait)" srcset="../assets/img/titelbild_weiss.jpg">
            <source media="(orientation: landscape)" srcset="../assets/img/titelbild_weiss.jpg">
        </template>
        <template #headline>Die Europäische Union</template>
        <template #subline>Entdecke die 27 Mitgliedsländer</template>
        <template #text>
        </template>
        <template #update>
            05.06.24
        </template>
    </Home>
</template>

<script>
    export default {
        name: 'home',
        babylonState: {
            camera: {
                position: [-1.57,0.01,70],
                animationSpeed: 280,
                // target: [0,0,-3],
                // alphaLimits:[-1.57,-1.57],
                // betaLimits:[0,0],
                // radiusLimits: [5, 60],
                //invertRotation: true,
            },
            zdfLogo: false,

        europa:{
                geo_sterne:{
                        visible: true,
                        pickable: false,
                        fade: true,
                    },
                    geo_eulabel:{
                    fade: true,
                    visible: false,
                },

        }
        },
        babylonReady: function ()
        {

            this.$babylonController.startAnimation("anim_sterne",1,.03);

            //Alle Länder aus

            this.$babylonController.goToAnimation("anim_eulabel", 0);


            this.$babylonController.goToAnimation("anim_belgien", 0);
            this.$babylonController.goToAnimation("anim_bulgarien", 0);
            this.$babylonController.goToAnimation("anim_daenemark", 0);
            this.$babylonController.goToAnimation("anim_deutschland", 0);
            this.$babylonController.goToAnimation("anim_estland", 0);
            this.$babylonController.goToAnimation("anim_finnland", 0);
            this.$babylonController.goToAnimation("anim_frankreich", 0);
            this.$babylonController.goToAnimation("anim_griechenland", 0);
            this.$babylonController.goToAnimation("anim_italien", 0);
            this.$babylonController.goToAnimation("anim_irland", 0);
            this.$babylonController.goToAnimation("anim_kroatien", 0);
            this.$babylonController.goToAnimation("anim_litauen", 0);
            this.$babylonController.goToAnimation("anim_lettland", 0);
            this.$babylonController.goToAnimation("anim_luxemburg", 0);
            this.$babylonController.goToAnimation("anim_malta", 0);
            this.$babylonController.goToAnimation("anim_niederlande", 0);
            this.$babylonController.goToAnimation("anim_oesterreich", 0);
            this.$babylonController.goToAnimation("anim_polen", 0);
            this.$babylonController.goToAnimation("anim_portugal", 0);
            this.$babylonController.goToAnimation("anim_rumaenien", 0);
            this.$babylonController.goToAnimation("anim_schweden", 0);
            this.$babylonController.goToAnimation("anim_slowakei", 0);
            this.$babylonController.goToAnimation("anim_slowenien", 0);
            this.$babylonController.goToAnimation("anim_spanien", 0);
            this.$babylonController.goToAnimation("anim_tschechien", 0);
            this.$babylonController.goToAnimation("anim_ungarn", 0);
            this.$babylonController.goToAnimation("anim_zypern", 0);

            //Bewegte Info Geos ausschalten
            this.$babylonController.setVisibility("geo_info_belgien",0);
            this.$babylonController.setVisibility("geo_info_bulgarien",0);

            this.$babylonController.setVisibility("geo_info_daenemark",0);
            this.$babylonController.setVisibility("geo_info_deutschland",0);
            this.$babylonController.setVisibility("geo_info_estland",0);

            this.$babylonController.setVisibility("geo_info_finnland",0);
            this.$babylonController.setVisibility("geo_info_frankreich",0);
            this.$babylonController.setVisibility("geo_info_griechenland",0);

            this.$babylonController.setVisibility("geo_info_irland",0);
            this.$babylonController.setVisibility("geo_info_italien",0);
            this.$babylonController.setVisibility("geo_info_kroatien",0);
            this.$babylonController.setVisibility("geo_info_litauen",0);

            this.$babylonController.setVisibility("geo_info_lettland",0);


            this.$babylonController.setVisibility("geo_info_luxemburg",0);
            this.$babylonController.setVisibility("geo_info_malta",0);
            this.$babylonController.setVisibility("geo_info_niederlande",0);
            this.$babylonController.setVisibility("geo_info_oesterreich",0);
            this.$babylonController.setVisibility("geo_info_rumaenien",0);


            this.$babylonController.setVisibility("geo_info_schweden",0);
            this.$babylonController.setVisibility("geo_info_slowakei",0);

            this.$babylonController.setVisibility("geo_info_slowenien",0);

            this.$babylonController.setVisibility("geo_info_spanien",0);
            this.$babylonController.setVisibility("geo_info_tschechien",0);
            this.$babylonController.setVisibility("geo_info_polen",0);

            this.$babylonController.setVisibility("geo_info_portugal",0);
            this.$babylonController.setVisibility("geo_info_ungarn",0);
            this.$babylonController.setVisibility("geo_info_zypern",0);




        },
        // methods: {
        //     next: function () {
        //         this.$tracking.navigationClick('Start');
        //         this.$eventBus.$emit('nextPage');
        //     }
        // },
    }
</script>

<style lang="scss">

    .home {

        // change default opacity: 0.35
        .home__background {

            opacity: .4;
        }
        // change default object-position: unset (50% 50%)  / Für Portrait ist nur der x-Wert relevant, für Landscape nur der y-Wert. / Einheit entweder in "%" oder "px"
        .home__background img.o-fit {

            //object-position: 50% 0%;
            //
            //@media (orientation: landscape) {
            //
            //    object-position: 0% 50%;
            //}
        }
    }

</style>
